import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis,
  CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Per-day, per-platform active-users trend line for Daily active users.
 * Derived entirely from the daily table data (no extra API). Expects the rows
 * in ASCENDING date order.
 *
 * Props: { data }  — array of {access_date, android_users, ios_users, ...}
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const ActiveUsersTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;

  return (
    <div className="au-panel" data-testid="au-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Active users per day · by platform</h4>
        <span className="au-spacer" />
        <div className="au-legend" aria-hidden="false">
          <span><i className="au-dot--android" style={{ background: '#2e9b87' }} />Android</span>
          <span><i className="au-dot--ios" style={{ background: '#f26b45' }} />iOS</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={220} data-testid="au-trend-chart">
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="access_date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value, name) => [Number(value).toLocaleString(), name]}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="android_users" name="Android" stroke="#2e9b87" strokeWidth={2.5} dot={false} />
            <Line type="monotone" dataKey="ios_users" name="iOS" stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="au-trend-empty">
          Need at least 2 days of data to plot a trend.
        </div>
      )}
    </div>
  );
};

export default ActiveUsersTrendChart;
